import { produce } from 'immer';

import { RemoveInternalBannerImage } from '../../../actions/imageEditor/internal/removeInternalBannerImage';
import { getEmptyBannerImage } from '../../../service/BannerHelpers/BannerHelpers';
import { getImageEditorIdByBannerId } from '../../../service/ImageHelpers/ImageHelpers';
import { ImageEditorsState } from '../../../typings/state';

export function removeInternalBannerImage(
    state: ImageEditorsState,
    action: RemoveInternalBannerImage
): ImageEditorsState {
    const id = getImageEditorIdByBannerId(action.bannerId, action.resourceId);

    return produce(state, draft => {
        const fixedSize = draft[id].image.fixedSize;

        draft[id].image = getEmptyBannerImage();
        draft[id].image.fixedSize = fixedSize;
    });
}
